import { render, staticRenderFns } from "./authMain.vue?vue&type=template&id=710773b6&scoped=true&"
import script from "./authMain.vue?vue&type=script&lang=js&"
export * from "./authMain.vue?vue&type=script&lang=js&"
import style0 from "./authMain.vue?vue&type=style&index=0&id=710773b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710773b6",
  null
  
)

export default component.exports